import { HttpEvent, HttpEventType, HttpResponse } from "@angular/common/http";
import { Observable, filter, map } from "rxjs";
export const filterHttpResponse = <T extends any>() => (obs: Observable<HttpEvent<T>>) => obs.pipe(
    filter((httpEvent: HttpEvent<T>) => httpEvent.type === HttpEventType.Response),
    map((httpEvent) => (<HttpResponse<T>>httpEvent).body)
);